import React from "react";
import PropTypes from "prop-types";
import { HeroWrapper } from "./styles";
import { CtaButton } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { COLOR_WHITE } from "@website-builder/utilities-index";

const HeroWithImage = (props) => {
	const { header, description, fontColor, showInTabletAndMobile, image, cta } =
		props;

	return (
		<HeroWrapper
			fontColor={fontColor}
			showInTabletAndMobile={showInTabletAndMobile}
		>
			<div className="joinusWrapper">
				<h2 className="header">{header}</h2>
				<p className="description">{description}</p>
				{cta && <CtaButton cta={cta} className="join-button" />}
			</div>
			<div className="imageWrapper">
				<CloudinaryImage
					lazyload
					className="heroImage"
					url={image}
					sizes={{ default: { height: 516 }, "322px": { height: 516 } }}
				/>
			</div>
		</HeroWrapper>
	);
};

HeroWithImage.propTypes = {
	header: PropTypes.string,
	description: PropTypes.string,
	fontColor: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
	image: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
};

HeroWithImage.defaultProps = {
	header: "",
	description: "",
	fontColor: COLOR_WHITE,
	showInTabletAndMobile: true,
	image: "",
	cta: null,
};

export default HeroWithImage;
